import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListAffairePage = withAsyncLoading(async () =>
    import('./ListAffairePage').then((res) => res.ListAffairePage)
);

export { LoadableListAffairePage };
